import { BRAND_NAME } from '../../lib/brand';
import { cn } from '../../lib/cn';

/**
 * The product mark: three bars of a voice wave, the tallest sprouting a forward stroke
 * (also reads as a lowercase k). Same geometry as docs/brand/kinetly-mark.svg.
 */
export function Mark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 100 100"
      fill="none"
      stroke="currentColor"
      strokeWidth="11"
      strokeLinecap="round"
      className={className}
      aria-hidden="true"
    >
      <path d="M19 54v20M38 40v34M57 26v48M57 42l24-9" />
    </svg>
  );
}

/** The mark on a lime tile and the product name. */
export function Logo({ className }: { className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2 min-w-0', className)}>
      <span className="flex-shrink-0 inline-flex items-center justify-center w-6 h-6 rounded-lg bg-accent text-accent-on">
        <Mark className="w-5 h-5" />
      </span>
      <span className="text-lg font-extrabold truncate">{BRAND_NAME}</span>
    </span>
  );
}
